import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Wrench, ArrowRight } from "lucide-react";
import { BUSINESS, SERVICES } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-zinc-400">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2.5 mb-5">
              <span className="flex items-center justify-center w-10 h-10 rounded-md bg-red-600 text-white">
                <Wrench size={20} />
              </span>
              <span className="font-heading text-2xl font-bold tracking-tight text-white">
                Caliber<span className="text-red-500">AUTO</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed mb-5">
              Veteran-owned autobody shop that treats you as the customer — not your insurance company.
            </p>
            <span className="inline-block text-[10px] font-bold tracking-[0.25em] uppercase text-red-500 border border-red-600/40 rounded-full px-4 py-1.5">
              Level Above The Class
            </span>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-white text-lg font-bold uppercase tracking-wider mb-5">Our Services</h4>
            <ul className="space-y-2.5 text-sm">
              {SERVICES.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <Link to="/services" className="flex items-center gap-2 hover:text-red-500 transition-colors duration-200">
                    <ArrowRight size={13} className="text-red-600" />
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-heading text-white text-lg font-bold uppercase tracking-wider mb-5">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              {[
                { to: "/", label: "Home" },
                { to: "/services", label: "Services" },
                { to: "/gallery", label: "Gallery" },
                { to: "/testimonials", label: "Testimonials" },
                { to: "/appointment", label: "Make an Appointment" },
                { to: "/contact", label: "Contact Us" },
              ].map((l) => (
                <li key={l.to + l.label}>
                  <Link to={l.to} className="flex items-center gap-2 hover:text-red-500 transition-colors duration-200">
                    <ArrowRight size={13} className="text-red-600" />
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-white text-lg font-bold uppercase tracking-wider mb-5">Get In Touch</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-red-500 mt-0.5 shrink-0" />
                <a href={BUSINESS.mapUrl} target="_blank" rel="noreferrer" className="hover:text-red-500 transition-colors">
                  {BUSINESS.address}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-red-500 shrink-0" />
                <a href={BUSINESS.phoneHref} className="hover:text-red-500 transition-colors">{BUSINESS.phone}</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-red-500 shrink-0" />
                <a href={`mailto:${BUSINESS.email}`} className="hover:text-red-500 transition-colors break-all">{BUSINESS.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} className="text-red-500 mt-0.5 shrink-0" />
                <div className="space-y-1">
                  {BUSINESS.hours.map((h) => (
                    <div key={h.day}>
                      <span className="text-zinc-300">{h.day}:</span> {h.time}
                    </div>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-14 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs">
          <p>© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p className="text-zinc-500">Veteran-Owned • Bedford, Ohio</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
